<template>
	<div class="ui segment">
		<div class="ui top attached label"><i class="globe icon"></i> Climate and geology :</div>
		<div class="ui segment">
			<div class="ui top left attached label">Climates</div>
			<div v-for="(climate, index) in climates" :key="index">
				{{climate}}
			</div>
		</div>
		<div class="ui segment">
			<div class="ui top left attached label">Geologies</div>
			<div v-for="(geology, index) in geologies" :key="index">
				{{geology}}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:["climates","geologies"]
}
</script>

<style>

</style>
